import React, { useContext, useEffect, useState } from "react";
import "../../../assests/css/studentdashboard/StudentExam.css";
import StudentsideLayout from "../../../layouts/StudentsideLayout";
import { AppContext } from "../../../context/Appcontext";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";

const StudentExam = () => {
  const [activeView, setActiveView] = useState(null);
  const { loggedInStudent, baseUrl, baseUrlForFiles } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [dateSheet, setDateSheet] = useState("");
  const [examId, setExamId] = useState(null);

  const [resultData, setResultData] = useState([]);

  const fetchAllExamSheet = () => {
    if (!loggedInStudent) return;
    console.log(loggedInStudent);
    const formData = new FormData();
    formData.append("semester", loggedInStudent.semester);
    formData.append("ngprogramme_id", loggedInStudent.ngprogramme_id);
    console.log(baseUrl);
    console.log(`${baseUrl}/student/exam/fetchAllExamSheet`);
    axios
      .post(`${baseUrl}/student/exam/fetchAllExamSheet`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log("Exam API Response:", response.data);

        if (response.data.exam) {
          console.log("Exam Object:", response.data.exam);
          console.log("Exam ID:", response.data.exam.id);

          setExamId(response.data.exam.id);
          setDateSheet(response.data.exam.fileName);
        } else {
          console.log("No exam found");
        }
      });
  };

  const fetchStudentResult = () => {
    if (!loggedInStudent) return;

    const formData = new FormData();

    formData.append("ngstudent_id", loggedInStudent.id);
    console.log("Logged In Student:", loggedInStudent);
    console.log("Student ID:", loggedInStudent.id);
    axios
      .post(`${baseUrl}/student/result/fetchStudentResult`, formData)
      .then((response) => {
        console.log(response.data);

        if (response.data.success) {
          setResultData(response.data.results);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleRaiseDispute = () => {
    console.log("Current examId:", examId);

    if (!examId) {
      alert("Exam ID is null");
      return;
    }

    navigate("/help/support", {
      state: {
        request_type: "exam_dispute",
        issue_type: "Exam / Result Issue",
        reference_id: examId,
        admin_id: 1,
      },
    });
  };

  const handleResultDispute = (result) => {
    console.log("Selected Result:", result);

    if (!result?.id) {
      alert("Result ID is missing");
      return;
    }

    navigate("/help/support", {
      state: {
        request_type: "result_dispute",
        issue_type: "Result / Marks Issue",
        reference_id: result.id,
        ngstudent_id: loggedInStudent.id,

        // Agar result mein teacher id available hai
        ngteacher_id: result.ngteacher_id || result.ngteacher?.id || null,
      },
    });
  };
  useEffect(() => {
    if (loggedInStudent?.id) {
      fetchAllExamSheet();
      fetchStudentResult();
    }
  }, [loggedInStudent]);
  return (
    <StudentsideLayout>
      <div className="exam-page-wrapper">
        <div className="container exam-container">
          <div className="page-header">
            <h1 className="page-title">Exam Portal</h1>
            <p className="page-subtitle">
              View your examination schedule and results
            </p>
          </div>

          <div className="row button-row">
            <div className="col-6 button-col">
              <button
                className={`action-button ${activeView === "schedule" ? "active" : ""}`}
                onClick={() =>
                  setActiveView(activeView === "schedule" ? null : "schedule")
                }
              >
                <span className="button-icon">📅</span>
                Download Schedule
              </button>
            </div>
            <div className="col-6 button-col">
              <button
                className={`action-button ${activeView === "result" ? "active" : ""}`}
                onClick={() =>
                  setActiveView(activeView === "result" ? null : "result")
                }
              >
                <span className="button-icon">📊</span>
                Download Result
              </button>
            </div>
          </div>

          {activeView === "schedule" && (
            <div className="table-container">
              <h2 className="table-heading">Examination Schedule</h2>
              <div className="table-responsive">
                {dateSheet ? (
                  <div className="exam-file-box">
                    <a
                      href={`${baseUrlForFiles}/${dateSheet}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="exam-file-link"
                    >
                      📄 View / Download Examination Schedule
                    </a>
                  </div>
                ) : (
                  <p className="exam-no-file">
                    Examination schedule is not available.
                  </p>
                )}
                <div className="mt-3 text-end">
                  <button
                    className="btn btn-danger"
                    onClick={handleRaiseDispute}
                  >
                    Raise Dispute
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeView === "result" && (
            <div className="table-container">
              <h2 className="table-heading">Examination Results</h2>
              <div className="table-responsive">
                <table className="table custom-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Subject</th>
                      <th>Marks</th>
                      {/* <th>Grade</th> */}
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resultData.map((item) => (
                      <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>{item.ngcourse?.name}</td>
                        <td>{item.obtainMarks}</td>
                        {/* <td>-</td> */}
                        <td>
                          <span
                            className={`status-badge ${item.obtainMarks >= 50 ? "pass" : "fail"
                              }`}
                          >
                            {item.obtainMarks >= 50 ? "Pass" : "Fail"}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="mt-3 text-end">
                <button
                  className="btn btn-danger"
                  onClick={() => handleResultDispute(resultData[0])}
                >
                  Raise Result Dispute
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </StudentsideLayout>
  );
};

export default StudentExam;
